export default {
  default: {
    tabTitle: 'Photos & Plans',
    title: 'Media',
    upload: 'Upload',
  },
}
